module.exports = __webpack_public_path__ + "static/media/RESULTATPASENCOREREVENU.5cd6bcda.svg";